import { render, staticRenderFns } from "./PageFinale.vue?vue&type=template&id=fa2b69dc&scoped=true&"
import script from "./PageFinale.vue?vue&type=script&lang=js&"
export * from "./PageFinale.vue?vue&type=script&lang=js&"
import style0 from "./PageFinale.vue?vue&type=style&index=0&id=fa2b69dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2b69dc",
  null
  
)

export default component.exports